import { TopNavigation } from 'features/topNavigation/TopNavigation';
import { Outlet } from 'react-router-dom';

export const PATHS_WITHOUT_TOP_NAV: string[] = [];

export function AuthenticatedRoutesWrapper() {
    return (
        <>
            <TopNavigation />
            <Outlet />
        </>
    );
}
